import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CoalitionCardExtrasDetail,
  CoalitionModal,
  CoalitionButton,
  EmptyBlock,
  CoalitionCardExtras,
  CoalitionSpinner,
  isTokenValid,
} from "./../components";
import {
  tokenSolver,
  getFromStorage,
  extras,
  scrollToTop,
  privGtmKey,
  getImg,
  toggleScrollLock,
  getCardDetail,
} from "../utils";
import { chevron_left, empty_extras } from "./../pngs";
import {
  sendTag,
  event_properties_103_01,
  event_properties_103_02,
} from "./../components/CoalitionGtm";

export const ExtrasPage = () => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_103_01());
  }, [gtm]);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [extraPoints, updateExtraPoints] = useState([]);

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const setExtraPointsCards = async () => {
      setLoading(true);
      const rawExtraPoints = getFromStorage(extras);
      await updateExtraPoints(rawExtraPoints);
      setLoading(false);
      scrollToTop();
    };
    setExtraPointsCards();
  }, []);

  return loading ? (
    <CoalitionSpinner />
  ) : (
    <div className="specific-page">
      <PagePrebuilt
        extras={extraPoints}
        buttonClicked={() => navigate(`/?${tokenSolver()}`)}
      />
    </div>
  );
};

const PagePrebuilt = ({ extras = [], buttonClicked }) => {
  const gtm = localStorage.getItem(privGtmKey);
  const handleClick = (id, label) => {
    toggleModal(id);
    if (gtm) {
      let payload = event_properties_103_02();
      payload.extra_points_id = id;
      payload.partner = label;
      payload.click_id = null;
      sendTag(gtm, payload);
    }
  };

  const [modal, setModal] = useState();
  const [shown, setShown] = useState(false);
  const [activeCard, setActiveCard] = useState();

  const toggleModal = (modal = false) => {
    setShown(Boolean(modal));
    toggleScrollLock();
    setActiveCard(getCardDetail(extras, modal));
  };

  return (
    <>
      {!extras || extras.length === 0 ? (
        <>
          <EmptyBlock
            title={"Puntos adicionales"}
            description={
              "Muy pronto podrás ganar más puntos en el total de tu compra"
            }
            emptyState={empty_extras}
          >
            <CoalitionButton
              label="Volver al Inicio"
              klass="coalition-button-go-dashboard"
              onClickEvent={buttonClicked}
            />
          </EmptyBlock>
        </>
      ) : (
        <>
          <div className="carousel-cards">
            <>
              <CoalitionButton
                label={"Puntos adicionales"}
                klass="nav-button"
                onClickEvent={buttonClicked}
              >
                {getImg(chevron_left, "back-icon")}
              </CoalitionButton>
            </>
            <div className="title">{"Premios disponibles"}</div>
            <div className="description">
              {"Cambia tus puntos por productos de regalo"}
            </div>
            {extras.map((i, k) => (
              <CoalitionCardExtras
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                expiracy={i.valid_until}
                extraPoints={i.extra_points}
                showModal={() => handleClick(i.id, i.sponsor_name)}
                fromPage={true}
              />
            ))}
          </div>
          {shown ? (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={"Todo sobre tus Puntos adicionales"}
            >
              <CoalitionCardExtrasDetail card={activeCard} />
            </CoalitionModal>
          ) : null}
        </>
      )}
    </>
  );
};
